<script>
    export default {
        name: "TermsAndConditions",
    }
</script>

<template>
    <div class="terms-content">
        <h1 class="mt-0">Terms of Use</h1>
        
    </div>
</template>

<style lang="scss" scoped>
    .terms-content {
        color:#2e3c54;margin:30px auto 100px;max-width:1100px;
        h1,h2,h3,h4,h5,h6{font-family:"Nunito",serif}
        p{font-family:"Nunito",sans-serif;padding:.5em 0; font-size: 95%; line-height: 1.1;}
        p.description{font-size:1.1em;padding:0.5em 0 1.5em}
        html{font-size:90%;-ms-text-size-adjust:100%;-webkit-text-size-adjust:100%}
        a:focus{outline:thin dotted}
        a:active,a:hover{outline:0}
        strong,li{line-height: 1.1;}
        ul{padding-left: 10px;}
        h1{font-size:1.8em;margin:0; padding-top: 15px; -webkit-margin-before:0;-webkit-margin-after:0}
        h2{font-size:1.5em;margin:0; padding-top: 15px; -webkit-margin-before:0;-webkit-margin-after:0}
        h3{font-size:1.17em;margin:0; padding-top: 15px; -webkit-margin-before:0;-webkit-margin-after:0}
        h4{font-size:1em;margin:0; padding-top: 15px; -webkit-margin-before:0;-webkit-margin-after:0}
        h5{font-size:0.83em;margin:0; padding-top: 15px; -webkit-margin-before:0;-webkit-margin-after:0}
        h6{font-size:0.67em;margin:0; padding-top: 15px; -webkit-margin-before:0;-webkit-margin-after:0}
    }
</style>